import React from 'react';
import { bool, number, func } from 'prop-types';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { Checkbox } from '@fiverr-private/fit';
import { formatSimpleNumber } from '../../../../utils';
import '../style.scss';

const validate = ({ filterCount = 0 }) => filterCount > 0;

const WorkSample = ({ workSampleChecked = false, filterCount = 0, onToggle = noop, multipleFilters = false }) => {
    if (!validate({ filterCount })) {
        return null;
    }

    return (
        <div className="toggle-filter work-sample-filter col-12-xs">
            <Checkbox id="worksample-filter" checked={workSampleChecked} onChange={onToggle}>
                <label className="toggle-filter-text" htmlFor="worksample-filter">
                    {multipleFilters ? (
                        <I18n k="reviews.filters.work_sample_delivery_image" params={{ filterCount }} />
                    ) : (
                        <I18n k="reviews.work_sample" params={{ filterCount: formatSimpleNumber(filterCount) }} />
                    )}
                </label>
            </Checkbox>
        </div>
    );
};

WorkSample.propTypes = {
    workSampleChecked: bool,
    filterCount: number,
    onToggle: func,
    multipleFilters: bool,
};

export default WorkSample;
